import { render } from "./ExamCreateWizard.vue?vue&type=template&id=4e35c258&scoped=true"
import script from "./ExamCreateWizard.vue?vue&type=script&lang=js"
export * from "./ExamCreateWizard.vue?vue&type=script&lang=js"

import "./ExamCreateWizard.vue?vue&type=style&index=0&id=4e35c258&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e35c258"]])

export default __exports__